<template>
    <table class="text-left w-full border-collapse" id="contact_table">
        <thead>
        <tr class="font-bold uppercase text-sm text-grey-darkest border-b border-grey-light">
            <th class="pl-2" v-for="columnToShow in availableColumns">
                <button v-if="availableSort[columnToShow.property_name]" class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                        :class="currentOrder.sortBy === columnToShow.property_name ? 'text-teal' : ''"
                        @click="sortByColumn(columnToShow.property_name)">
                    {{ columnToShow.name }}
                    <i class="fa fa-xs ml-2" :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                            'fa-chevron-down' : currentOrder.direction === 'desc'}"
                       v-if="currentOrder.sortBy === columnToShow.property_name"></i>
                </button>
                <button v-else class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none">
                    {{ columnToShow.name }}
                </button>
            </th>
            <th class="pl-2 border-l-1 text-center" style="width:5%">
                <contact-export-icon
                    name="Contacts"
                    :contacts="{}"
                    :state="columns"
                    :filter="{}"
                    v-on:contactStateUpdated="updateColumnState"
                    :isListExport="true"
                    :list="list"
                    :isCompanyInformation="false"
                />
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="items.length > 0" v-for="contact in items" class="text-sm">
            <td v-for="column in availableColumns" class="pl-2 border-b border-grey-light text-xs md:table-cell td-text-overflow"
                :class="(column.property_name !== 'name' && column.property_name !== 'contact')  ? 'hidden' : ''"
            >
                <div v-show="column.property_name === 'cell'" :class="(column.property_name !== 'id') ? 'text-break' : ''">
                    <formatted-phone
                        v-if="contact['cell']" :phone="contact['cell']" :masks="masks"/>
                </div>
                <a v-show="column.property_name === 'email'" :href="`mailto:${contact.email ? contact.email : ''}`"
                   class="text-teal hover:text-teal-dark" :class="(column.property_name !== 'id') ? 'text-break' : ''">
                    {{ contact.email }}
                </a>
                <span v-show="column.property_name !== 'email' && column.property_name !== 'cell' && column.property_name !== 'contact_status' && !column.is_custom_field && !column.is_sales_behavior" :class="(column.property_name !== 'id') ? 'text-break' : ''">
                    {{ contact[column.property_name] }}
                </span>
                <span v-show="column.property_name === 'contact_status' ? 'text-break' : ''">
                    {{ contact['contact_status_name'] }}
                </span>
                <span v-show="column.is_sales_behavior">
                    {{ getSalesBehaviorDate(column, contact.sales_behavior_data) }}
                </span>
                <div v-if="column.is_custom_field ? 'text-break' : ''">
                    {{ contact[column.property_name] }}
                </div>
            </td>

            <td class="px-4 text-right hidden md:table-cell border-l-1 cursor-pointer  border-b border-grey-light" @click="goToContact(contact)">
                <span class="material-icons">chevron_right</span>
            </td>
        </tr>
        <tr v-else class="text-center"><td colspan="9">No record found!</td></tr>
        </tbody>
    </table>
</template>
<script>

import FormattedPhone from '../../shared/formatted-phone.vue';

export default {
    name: 'contact',
    props: [
        'availableColumns',
        'availableSort',
        'items',
        'masks',
        'list',
        'contactCustomFields',
        'contactCustomFieldTypeConstants',
        'currentOrder',
        'contactSalesBehaviors',
        'calendar'
    ],
    components: {FormattedPhone},
    data () {
        let contactState = this.list.states
        const stateCustomFields = this.contactCustomFields.map(customField => ({
            name: customField.label_value,
            checked: true,
            property_name: customField.name,
            is_custom_field: true,
            custom_field_id: customField.id,
            custom_field_type: this.contactCustomFieldTypeConstants[customField.type],
        }));
        const stateSalesBehaviors = this.contactSalesBehaviors.map(salesBehavior => ({
            name: salesBehavior.name,
            checked: true,
            property_name: salesBehavior.name,
            is_sales_behavior: true,
            sales_behavior_id: salesBehavior.id,
        }));
        let newState = [
            {
                name: 'Contact ID',
                checked: true,
                property_name: 'id',
            },
            {
                name: 'Contact',
                checked: true,
                property_name: 'name',
            },
            {
                name: 'Address',
                checked: true,
                property_name: 'address',
            },
            {
                name: 'City',
                checked: true,
                property_name: 'city',
            },
            {
                name: 'State',
                checked: true,
                property_name: 'state',
            },
            {
                name: 'Zip',
                checked: true,
                property_name: 'zip',
            },
            {
                name: 'Email',
                checked: true,
                property_name: 'email',
            },
            {
                name: 'Cell',
                checked: true,
                property_name: 'cell',
            },
            {
                name: 'Title',
                checked: true,
                property_name: 'title',
            },
            {
                name: 'Followup',
                checked: true,
                property_name: 'date',
            },
            {
                name: 'User',
                checked: true,
                property_name: 'user',
            },
            {
                name: 'Company Name',
                checked: true,
                property_name: 'company_name',
            },
            {
                name: 'Contact Type',
                checked: true,
                property_name: 'contact_type',
            },
            {
                name: 'Contact Status',
                checked: true,
                property_name: 'contact_status',
            },
            {
                name: 'Created Date',
                checked: true,
                property_name: 'created_date',
            },
            {
                name: 'Last Update',
                checked: true,
                property_name: 'last_update',
            },
            ...stateCustomFields,
            ...stateSalesBehaviors
        ];
        // if (contactState) {
        //     const stateHash = contactState.reduce(function (map, obj) {
        //         map[obj.name] = obj;
        //         return map;
        //     }, {});
        //     newState = Object.values(stateHash);
        // }else{
        //     const baseStateHash = newState.reduce(function (map, obj) {
        //         map[obj.name] = obj;
        //         return map;
        //     }, {});
        //     newState = Object.values(baseStateHash);
        // }
        return {
            columnsToExport: [],
            columns: contactState ? contactState : newState,
            sortOrder: this.currentOrder,
            dateFormat: this.calendar? 'MM/DD/yyyy hh:mm:ss A' : 'MM/DD/yyyy',
        }
    },
    created() {
    },
    methods: {
        goToContact(contact) {
            window.location = route('contact.edit', {company: contact.company_id, contact: contact.id})
        },
        updateColumnState(updatedStates) {
            this.columnsToExport = updatedStates.filter((updatedState) => {
                if(updatedState.checked){
                    return updatedState
                }
            })
            this.$emit('columnsToExportUpdated', this.columnsToExport);
        },
        sortByColumn(sortBy) {
            const self = this;
            if (sortBy === self.sortOrder.sortBy) {
                self.sortOrder.direction = (self.sortOrder.direction === 'asc') ? 'desc' : 'asc'
            } else {
                self.sortOrder.sortBy = sortBy
                self.sortOrder.direction = 'desc';
            }
            this.$emit('sortingUpdated', self.sortOrder);
        },
        getSalesBehaviorDate(column, salesBehaviors) {
            let date = null;
            let self = this;
            _.forEach(salesBehaviors, function(data) {
                if(data.id === column.sales_behavior_id) {
                    if(data.date && data.date !== ""){
                         date = moment(data.date).format(self.dateFormat)
                    }
                }
            });
            return date;
        }
    }
}
</script>
